import { SITE } from "@/config/site";

// Reusable WhatsApp + phone helpers. The number lives in config/site.js only.
export const waLink = (message) =>
  `https://wa.me/${SITE.whatsapp}?text=${encodeURIComponent(message)}`;

export const telLink = `tel:${SITE.phoneRaw}`;

export const WA_MESSAGES = {
  general: `Hello ${SITE.name}, I would like to know more about your hospital services.`,
  appointment: `Hello ${SITE.name}, I would like to request an appointment.`,
  urgent: `Hello ${SITE.name}, I need urgent medical assistance. Please guide me.`,
  doctor: (doctorName) =>
    `Hello, I would like to book an appointment with ${doctorName}. Please let me know the available appointment time.`,
  appointmentRequest: ({ name, mobile, doctor, date, time, reason }) =>
    [
      `Hello ${SITE.name},`,
      "",
      "I would like to request an appointment.",
      "",
      `Patient Name: ${name}`,
      `Mobile: ${mobile}`,
      `Doctor: ${doctor}`,
      `Preferred Date: ${date}`,
      `Preferred Time: ${time}`,
      `Reason: ${reason}`,
      "",
      "Please confirm the appointment.",
    ].join("\n"),
};
